(() => {
  if (window.VRCheckoutContents) return;
  const propertyName = 'Je Konsole gratis';
  const normalize = name => name.replace(/^\s*\d+\s*×\s*/, '').replace(/\s+/g, ' ').trim();
  const format = names => [...new Set(names.map(normalize).filter(Boolean))].join(' · ') + ' (0,00 €)';
  const config = JSON.parse(document.getElementById('vr-included-config').textContent);
  const promoActive = () => !config.promoStartsAt || (Date.now() >= Date.parse(config.promoStartsAt) && Date.now() < Date.parse(config.promoEndsAt));
  if (config.promoStartsAt) {
    const campaignCode = config.code;
    Object.defineProperty(config, 'code', {get: () => promoActive() ? campaignCode : 'GRATIS-ZUR-KONSOLE'});
  }
  const ownedCodes = ['GRATIS-ZUR-KONSOLE', 'HAPPY-FRIDAY-SPECIAL', 'VR-FRIDAY-PREVIEW-21SEP', 'VR-PREVIEW-ACCESSORIES-7SEP'];
  const staleCode = code => ownedCodes.includes(String(code).toUpperCase()) && String(code).toUpperCase() !== config.code;
  const keepCode = code => code && !staleCode(code);
  const giftIds = new Set(Object.values(config.map).map(v => v.id));
  const propertiesOf = raw => Object.fromEntries(Array.isArray(raw) ? raw : Object.entries(raw || {}));
  let queue = Promise.resolve();
  let snapshot = null;
  let verifiedAt = 0;
  let revision = 0;
  let navigating = false;
  let priming = null;
  let primeRead = null;
  const invalidate = () => { verifiedAt = 0; revision++; };
  const enqueue = job => {
    const operation = queue.catch(() => {}).then(job);
    queue = operation;
    return operation;
  };
  const sectionIds = () => [...new Set([
    'cart-drawer', 'cart-icon-bubble', 'cart-included-checkout',
    document.getElementById('main-cart-items')?.dataset.id,
    document.getElementById('main-cart-footer')?.dataset.id,
  ].filter(Boolean))];
  function sectionsUrl() {
    const url = new URL(window.routes.cart_url, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id') ||
      (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id);
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  const parameters = () => {
    const url = sectionsUrl();
    return { sections: sectionIds(), sections_url: url.pathname + url.search };
  };
  async function request(path, data, signal) {
    let response;
    try {
      response = await fetch(path, {
        credentials: 'same-origin', cache: 'no-store', signal: signal || AbortSignal.timeout(20000),
        ...(data ? {method: 'POST', headers: {Accept:'application/json', 'X-Requested-With':'XMLHttpRequest', 'Content-Type':'application/json'}, body: JSON.stringify(data)} : {}),
      });
    } catch (error) { error.uncertain = Boolean(data); throw error; }
    let result;
    try { result = await response.json(); }
    catch (_) { const error = new Error('Die Antwort des Warenkorbs konnte nicht gelesen werden.'); error.uncertain = Boolean(data); throw error; }
    if (!response.ok || result.errors || result.status) {
      const error = new Error(result.description || (typeof result.errors === 'string' && result.errors) || 'Der Warenkorb konnte nicht aktualisiert werden.');
      error.status = response.status;
      error.uncertain = Boolean(data) && response.status >= 500;
      throw error;
    }
    return result;
  }
  function decode(sections, cartResponse) {
    const html = sections?.['cart-included-checkout'];
    if (typeof html !== 'string') throw new Error('Der Lieferumfang konnte nicht geladen werden.');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const cartNode = doc.querySelector('[data-vr-cart-snapshot]');
    if (!cartNode) throw new Error('Der Warenkorbstatus fehlt.');
    const cart = cartResponse?.item_count !== undefined ? cartResponse : JSON.parse(cartNode.textContent);
    if (!Array.isArray(cart.items)) throw new Error('Der Warenkorbstatus ist ungültig.');
    const parents = JSON.parse(doc.querySelector('[data-vr-cart-parents]').textContent);
    cart.items.forEach(item => {
      item.properties = propertiesOf(item.properties);
      item.parent_relationship = {parent_key: parents[item.key] || item.parent_relationship?.parent?.key || item.parent_relationship?.parent_key};
    });
    const desired = [...doc.querySelectorAll('[data-vr-line-key]')].flatMap(line =>
      [...line.querySelector('template').content.querySelectorAll('[data-vr-source-variant]')].map(row => {
        const gift = config.map[row.dataset.vrSourceVariant];
        if (!gift) throw new Error('Unbekannter Lieferumfang: ' + row.dataset.vrSourceVariant);
        return {id:gift.id, parent:line.dataset.vrLineKey, quantity:Number(line.dataset.vrQuantity)};
      })
    );
    return { cart, sections, desired: desired.filter(item => promoActive() || !config.map[item.id]?.promo) };
  }
  async function read() {
    const url = sectionsUrl();
    url.searchParams.set('sections', sectionIds().join(','));
    return decode(await request(url.toString()));
  }
  async function write(path, data) {
    const result = await request(path, {...data, ...parameters()});
    try { return decode(result.sections, result); }
    catch (_) {
      // A successful write is never repeated when section rendering fails.
      try { return await read(); } catch (error) {error.cartWritten = true; throw error;}
    }
  }
  const cartApi = path => window.Shopify.routes.root + path;
  const giftsOf = cart => cart.items.filter(item => giftIds.has(item.id) && item.properties._bundle_kind === 'included');
  async function reconcile(state) {
    state ||= await read();
    let changed = false;
    for (let count = 0; count < 100; count++) {
      const old = state.cart.items.find(item => Object.hasOwn(item.properties, propertyName));
      if (!old) break;
      const properties = {...old.properties};
      delete properties[propertyName];
      state = await write(cartApi('cart/change.js'), {id:old.key, quantity:old.quantity, properties});
      changed = true;
    }
    for (let pass = 0; pass < 5; pass++) {
      const updates = {};
      const missing = [];
      const used = new Set();
      for (const wanted of state.desired) {
        const matches = state.cart.items.filter(item => item.id === wanted.id && item.parent_relationship.parent_key === wanted.parent);
        if (!matches.length) missing.push({id:wanted.id, quantity:wanted.quantity, parent_line_key:wanted.parent,
          properties:{_bundle_hidden:'true', _bundle_kind:'included'}});
        else {
          matches.forEach(item => used.add(item.key));
          if (matches.length > 1) matches.forEach(item => { updates[item.key] = 0; });
          else if (matches[0].quantity !== wanted.quantity) updates[matches[0].key] = wanted.quantity;
        }
      }
      for (const item of giftsOf(state.cart)) if (!used.has(item.key)) updates[item.key] = 0;
      if (Object.keys(updates).length) {
        state = await write(cartApi('cart/update.js'), {updates}); changed = true; continue;
      }
      if (missing.length) {
        state = await write(cartApi('cart/add.js'), {items:missing}); changed = true; continue;
      }
      const oldPreviewCode = (state.cart.discount_codes || []).some(item => staleCode(item.code));
      if (giftsOf(state.cart).some(item => item.final_line_price !== 0) || oldPreviewCode) {
        // Preserve unrelated codes: Liquid does not guarantee discount_codes.
        const current = Array.isArray(state.cart.discount_codes) ? state.cart : await request(cartApi('cart.js'));
        const codes = (current.discount_codes || []).map(item => item.code).filter(keepCode);
        state = await write(cartApi('cart/update.js'), {discount:[...new Set([...codes, config.code])].join(',')});
        changed = true;
      }
      if (giftsOf(state.cart).some(item => item.final_line_price !== 0)) throw new Error('Gratis-Rabatt konnte nicht angewendet werden.');
      document.querySelectorAll('[data-vr-contents-error]').forEach(message => message.remove());
      return {...state, changed};
    }
    throw new Error('Bitte lade den Warenkorb erneut.');
  }
  function remember(state, version) {
    snapshot = state;
    verifiedAt = version === revision ? Date.now() : 0;
    return state;
  }
  const ensure = ({force = false} = {}) => {
    const requestedAt = Date.now();
    return enqueue(async () => {
      if (snapshot && verifiedAt && (!force ? Date.now() - verifiedAt < 60000 : verifiedAt >= requestedAt)) return {...snapshot, changed:false};
      const version = revision;
      return remember(await reconcile(), version);
    });
  };
  const mutate = (path, data) => {
    primeRead?.abort();
    invalidate();
    return enqueue(async () => {
      const version = revision;
      let written = false;
      try {
        const prepared = /\/cart\/add(?:\.js)?$/.test(path) && Array.isArray(data.items)
          ? {...data,items:window.VRCartPlan?.expand(data.items,snapshot?.cart) || data.items} : data;
        const initial = await write(path, prepared);
        written = true;
        const state = remember(await reconcile(initial), version);
        try { localStorage.setItem('vr-cart-updated', String(Date.now())); } catch (_) {}
        return state;
      } catch (error) {
        verifiedAt = 0;
        error.cartWritten = Boolean(error.cartWritten || written || error.uncertain);
        throw error;
      }
    });
  };
  const prime = () => {
    if (priming) return priming;
    const version = revision;
    const controller = new AbortController();
    primeRead = controller;
    const timer = setTimeout(()=>controller.abort(),3500);
    priming = request(cartApi('cart.js'),undefined,controller.signal).then(current=>{
      window.VRCartPlan?.setCart(current);
      const codes = (current.discount_codes || []).map(item=>item.code).filter(Boolean);
      if (codes.some(code=>code.toUpperCase()===config.code.toUpperCase())) return;
      return enqueue(async()=>{
        if (revision!==version) return;
        const state = await write(cartApi('cart/update.js'),{discount:[...codes.filter(keepCode),config.code].join(',')});
        snapshot = state;
        verifiedAt = 0;
      });
    }).catch(()=>{}).finally(()=>{
      clearTimeout(timer);
      if (primeRead===controller) primeRead=null;
      priming=null;
    });
    return priming;
  };
  const showError = target => {
    const host = target || document.querySelector('cart-drawer.active .drawer__footer') || document.querySelector('.cart__ctas') || document.querySelector('main');
    let message = host.querySelector('[data-vr-contents-error]');
    if (!message) {
      message = document.createElement('p'); message.dataset.vrContentsError = ''; message.setAttribute('role','alert'); host.append(message);
    }
    message.textContent = 'Der Gratis-Lieferumfang konnte gerade nicht abgeglichen werden. Du kannst den Warenkorb weiter bearbeiten. Bitte versuche es vor dem Bezahlen erneut.';
  };
  window.VRCheckoutContents = {ensure, mutate, prime, parameters, invalidate, get snapshot() {return snapshot;}, sync:options=>ensure(options).then(state=>state.changed), format, propertyName, showError};
  window.addEventListener('storage', event => { if (event.key === 'vr-cart-updated') invalidate(); });
  window.addEventListener('pageshow', event => { if (event.persisted) invalidate(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') invalidate(); });
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, event => { if (event.source !== 'vr-cart' && event.source !== 'vr-cart-rendered') invalidate(); });
  let campaignState = promoActive();
  let campaignRefresh = null;
  async function refreshCampaign() {
    if (!config.promoStartsAt || campaignRefresh) return;
    const next = promoActive();
    const view = document.querySelector('[data-vr-cart-view]');
    let stale = false;
    try { stale = !next && JSON.parse(view?.textContent || '{}').items?.some(item => config.map[item.id]?.promo); } catch (_) {}
    if (next === campaignState && !stale) return;
    campaignState = next;
    invalidate();
    campaignRefresh = ensure({force:true}).then(state => {if (state.changed) window.VRCart?.render(state, false);}).catch(() => { campaignState = !next; showError(); }).finally(() => {campaignRefresh=null;});
    return campaignRefresh;
  }
  document.addEventListener('vr-promo:ready', refreshCampaign);
  document.addEventListener('visibilitychange', () => {if (document.visibilityState === 'visible') refreshCampaign();});
  window.addEventListener('pageshow', refreshCampaign);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCampaign, {once:true});
  else refreshCampaign();
  async function checkout(event) {
    const control = event.type === 'submit' ? event.submitter : event.target.closest?.('[name="checkout"], a[href]');
    const isCheckout = control?.name === 'checkout' || (control?.tagName === 'A' && new URL(control.href, location.origin).pathname.replace(/\/$/, '').endsWith('/checkout'));
    if (!isCheckout) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (navigating) return;
    navigating = true; control.setAttribute('aria-busy','true');
    try {
      await ensure({force:true});
      location.assign(window.Shopify.routes.root + 'checkout');
    } catch (_) { navigating = false; control.removeAttribute('aria-busy'); showError(); }
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  if (location.pathname.replace(/\/$/, '') === window.routes.cart_url.replace(/\/$/, '')) {
    const express = [...document.querySelectorAll('.cart__dynamic-checkout-buttons')];
    express.forEach(area => {area.inert = true;});
    ensure().then(state => {
      if (state.changed) window.VRCart?.render(state, false);
      express.forEach(area => {area.inert = false;});
    }).catch(() => showError());
  }
})();
